import {Suspense} from "react";
import ReactDOM from 'react-dom';
import App from './App';
import {ConfigProvider} from 'antd';
import {Provider} from 'react-redux';
import {reduxStore} from "./services/redux/ReduxIndex";
import trTR from 'antd/es/locale-provider/tr_TR';
import reportWebVitals from './reportWebVitals';
import Api from './services/Api';
import UserInfo from './main/auth/UserInfo';
import { resolveSiteToken, SoulAnalytics } from './helpers/SoulAnalytics';
import { initSoulDataLayerBridge } from './helpers/SoulDataLayerBridge';


//!INFO global css eklenme alanı
import "./App.scss";

//!INFO çoklu dil yapısını import edelim
import './i18n';

let antdLocale = trTR;

try {
    const endpoint = String(Api.apiUrl() || '').replace(/\/api\/?$/, '/');
    let token = '';

    try {
        const userToken = JSON.parse(localStorage.getItem('userToken') || '{}');
        token = userToken?.token || '';
    } catch (e) {
        token = '';
    }

    const siteToken = resolveSiteToken();
    if (typeof window.__soulAnalyticsLoad === 'function') {
        window.__soulAnalyticsLoad(siteToken);
    }

    SoulAnalytics.configure({
        siteToken,
        authToken: token,
        endpoint,
        debug: window.location.host.indexOf('localhost') !== -1 || window.location.host.indexOf('-test') !== -1,
        consent: true,
        language: (navigator.language || 'tr').split('-')[0],
    });

    initSoulDataLayerBridge();

    const info = UserInfo.info();
    if (info && info.id) {
        SoulAnalytics.setUserData({
            userId: String(info.id),
            firstName: info.first_name,
            lastName: info.last_name,
            email: info.email,
            phone: info.phone || info.telephone,
            latitude: sessionStorage.getItem('_soul_latitude') || undefined,
            longitude: sessionStorage.getItem('_soul_longitude') || undefined,
        });
    }

    if (typeof window.soulTrackPageView === 'function') {
        window.soulTrackPageView();
    }
} catch (e) {
    // analytics init is best-effort
}

ReactDOM.render(
    <Provider store={reduxStore}>
        <ConfigProvider locale={antdLocale}>
            <Suspense fallback="">
                <App/>
            </Suspense>
        </ConfigProvider>
    </Provider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
